import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const FilterCalendar = ({ ...props }) => {
  const { onChangeDate } = props;
  let path = window.location.pathname;
  let date = path.split("/").reverse()[0].replaceAll(".html", "");

  const startDate = moment(date, "DD-MM-YYYY").toDate();

  const getStringTwoLetter = (letter) => {
    if (letter < 10) return "0" + letter;
    return letter;
  };

  const getFullDate = (date) => {
    return (
      getStringTwoLetter(date.getDate()) +
      "-" +
      getStringTwoLetter(date.getMonth() + 1) +
      "-" +
      date.getFullYear()
    );
  };

  const now = new Date();

  const convert = (d) => {
    return d.constructor === Date
      ? d
      : d.constructor === Array
      ? new Date(d[0], d[1], d[2])
      : d.constructor === Number
      ? new Date(d)
      : d.constructor === String
      ? new Date(d)
      : typeof d === "object"
      ? new Date(d.year, d.month, d.date)
      : NaN;
  };

  const compare = (a, b) => {
    return isFinite((a = convert(a).valueOf())) &&
      isFinite((b = convert(b).valueOf()))
      ? (a > b) - (a < b)
      : NaN;
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    nextDay(false);
    nextWeek(false);
    nextMonth(false);
  });

  //next day
  const nextDay = (isEvent = true) => {
    let currentDate = startDate;
    let date = new Date(currentDate);
    let next = date.setDate(date.getDate() + 1);
    let nextDay = new Date(next);
    let nextDays = getFullDate(nextDay);
    if (compare(now, date) < 0) {
      document.getElementById("next_day").classList.add("f_link");
    } else {
      if (isEvent) {
        document.getElementById("next_day").title = nextDays;
        window.location.href = "/ket-qua-xo-so/" + nextDays + ".html";
      }
    }
  };

  // next week
  const nextWeek = (isEvent = true) => {
    let date = new Date(startDate);
    let week = date.setDate(date.getDate() + 7);
    let nextWeek = new Date(week);
    let nextWeeks = getFullDate(nextWeek);
    if (compare(now, date) < 0) {
      document.getElementById("next_week").classList.add("f_link");
    } else {
      if (isEvent) {
        document.getElementById("next_week").title = nextWeeks;
        window.location.href = "/ket-qua-xo-so/" + nextWeeks + ".html";
      }
    }
  };

  // next month
  const nextMonth = (isEvent = true) => {
    let date = new Date(startDate);
    let month = date.setMonth(date.getMonth() + 1);
    let nextMonth = new Date(month);
    let nextMonths = getFullDate(nextMonth);
    if (compare(now, date) < 0) {
      document.getElementById("next_month").classList.add("f_link");
    } else {
      if (isEvent) {
        document.getElementById("next_month").title = nextMonths;
        window.location.href = "/ket-qua-xo-so/" + nextMonths + ".html";
      }
    }
  };

  //current
  const current = () => {
    let current = getFullDate(now);
    document.getElementById("current").title = current;
    window.location.href = "/ket-qua-xo-so/" + current + ".html";
  };

  // previous day
  const preDay = () => {
    let date = new Date(startDate);
    let pre = date.setDate(date.getDate() - 1);
    let preDay = new Date(pre);
    let preDays = getFullDate(preDay);
    document.getElementById("pre_day").title = preDays;
    window.location.href = "/ket-qua-xo-so/" + preDays + ".html";
  };

  // previous week
  const preWeek = () => {
    let date = new Date(startDate);
    let dateWeek = date.setDate(date.getDate() - 7);
    let preWeek = new Date(dateWeek);
    let preWeeks = getFullDate(preWeek);
    document.getElementById("pre_week").title = preWeeks;
    window.location.href = "/ket-qua-xo-so/" + preWeeks + ".html";
  };

  // previous month
  const preMonth = () => {
    let date = new Date(startDate);
    let month = date.setMonth(date.getMonth() - 1);
    let preMonth = new Date(month);
    let preMonths = getFullDate(preMonth);
    document.getElementById("pre_month").title = preMonths;
    window.location.href = "/ket-qua-xo-so/" + preMonths + ".html";
  };

  return (
    <div id="pagenav">
      <table border="0" align="center" cellSpacing="0" cellPadding="0">
        <tbody>
          <tr>
            <td>
              <ul className="pagenav">
                <li>
                  <a href="/ket-qua-xo-so/01-01-2005.html" title="01/01/2005">
                    &lt;&lt;&lt;&lt;
                  </a>
                </li>
                <li>
                  <button onClick={preMonth} id="pre_month">
                    &lt;&lt;&lt;
                  </button>
                </li>
                <li>
                  <button onClick={preWeek} id="pre_week">
                    &lt;&lt;
                  </button>
                </li>
                <li>
                  <button onClick={preDay} id="pre_day">
                    &lt;
                  </button>
                </li>
                <li>
                  <form onSubmit={onFormSubmit}>
                    <div className="form-group" id="get-day">
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => onChangeDate(date)}
                        name="startDate"
                        dateFormat="dd/MM/yyyy"
                        maxDate={new Date()}
                      />
                      <span className="get-day" />
                    </div>
                  </form>
                </li>
                <li>
                  <button onClick={nextDay} id="next_day">
                    &gt;
                  </button>
                </li>
                <li>
                  <button onClick={nextWeek} id="next_week">
                    &gt;&gt;
                  </button>
                </li>
                <li>
                  <button onClick={nextMonth} id="next_month">
                    &gt;&gt;&gt;
                  </button>
                </li>
                <li>
                  <button onClick={current} id="current">
                    &gt;&gt;&gt;&gt;
                  </button>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default FilterCalendar;
